<template>
  <div class="container-alerts">
    <ItemAlert v-for="(alert, index) in alerts" :key="index" :alert="alert"></ItemAlert>
  </div>
</template>
<script lang="ts">
import ItemAlert from '@/components/ItemAlert.vue';
import alertsModule from '@/store/modules/alerts.module';
import globalModule from '@/store/modules/global.module';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ItemAlert
  }
})
export default class Alerts extends Vue {
  get alerts(){
    return alertsModule.mapAlerts
  }
  mounted() {
    console.log('mounting alerts')
    globalModule.updateBodySize()
  }
}
</script>
<style lang="sass" scoped>
.container-alerts
  overflow-y: auto
  border: 2px solid rgba(40, 84, 239, .7)!important
</style>
